<template>
  <div class="list-container">
    <div v-if="insureLists.length==0" class="no-date">暂无保单</div>
    <div class="list-item" v-for="item in insureLists" :key="item.id">
      <div class="title">
        {{item.category.product.name}}
        <div v-if="item.state==1" class="paylink" @click="handlePayClick(item)">去支付</div>
      </div>
      <div class="time-box">
        <div class="left">创建时间</div>
        <div class="right">{{item.createTime}}</div>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="content-item-title">被保人</div>
          <div class="content-item-value">{{item.insureName}}</div>
        </div>
        <div class="content-item">
          <div class="content-item-title">保费</div>
          <div class="content-item-value">{{item.category.premium}}</div>
        </div>
        <div class="content-item">
          <div class="content-item-title">保单状态</div>
          <div class="content-item-value">{{item.state==2?'投保成功':item.state==0?'投保失败':'未支付'}}</div>
        </div>
      </div>
      <div class="phone-box" style="border-bottom: 1px solid #efeff2;">
        <div class="left">保单咨询电话</div>
        <div class="right" @click="handleCallPhoneClick(item,1)">{{item.showCallPhone1?'收起':'展开'}}</div>
        <div class="phone-content" v-show="item.showCallPhone1">
          <div>
            <p
              v-for="(item1,idx1) in
            $ComTools.isEmptyString(item.category.insurePhone)?[]:item.category.insurePhone.split(',')"
              :key="idx1"
            >
              <label class="call" @click="handleCallClick(item1)">{{item1}}</label>
            </p>
          </div>
        </div>
      </div>
      <div class="phone-box" style="border-bottom: 1px solid #efeff2;">
        <div class="left">理赔电话</div>
        <div class="right" @click="handleCallPhoneClick(item,2)">{{item.showCallPhone2?'收起':'展开'}}</div>
        <div class="phone-content" v-show="item.showCallPhone2">
          <div>
            <p
              v-for="(item2,idx2) in
            $ComTools.isEmptyString(item.category.indemnityPhone)?[]:item.category.indemnityPhone.split(',')"
              :key="idx2"
            >
              <label class="call" @click="handleCallClick(item2)">{{item2}}</label>
            </p>
          </div>
        </div>
      </div>
      <!--      <div-->
      <!--        class="phone-box"-->
      <!--        style="border-bottom: 1px solid #efeff2;"-->
      <!--        v-if="item.categoryId!=132&&item.categoryId!=133"-->
      <!--      >-->
      <!--        <div class="left">保单咨询电话</div>-->
      <!--        <div class="right" @click="handleCallPhoneClick(item,1)">{{item.showCallPhone1?'收起':'展开'}}</div>-->
      <!--        <div class="phone-content" v-show="item.showCallPhone1">-->
      <!--          <div v-if="item.categoryId == 101 || item.categoryId == 111">-->
      <!--            <p>-->
      <!--              <label-->
      <!--                class="call"-->
      <!--                style="margin-right:5rem"-->
      <!--                @click="handleCallClick('18595961771')"-->
      <!--              >18595961771</label>-->
      <!--              <label class="call" @click="handleCallClick('17637738312')">17637738312</label>-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-63177698')">0377-63177698</label>-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-61621899')">0377-61621899</label>-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-63121253')">0377-63121253</label>-->
      <!--            </p>-->
      <!--          </div>-->
      <!--          <div v-if="item.categoryId == 112">-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('18595961771')">18595961771</label>-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-63177698')">0377-63177698</label>-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-61621899')">0377-61621899</label>-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="phone-box">-->
      <!--        <div class="left">理赔电话</div>-->
      <!--        <div class="right" @click="handleCallPhoneClick(item,2)">{{item.showCallPhone2?'收起':'展开'}}</div>-->
      <!--        <div class="phone-content" v-show="item.showCallPhone2">-->
      <!--          <div v-if="item.categoryId == 101 || item.categoryId == 111">-->
      <!--            <p>-->
      <!--              <label-->
      <!--                class="call"-->
      <!--                style="margin-right:5rem"-->
      <!--                @click="handleCallClick('17698861762')"-->
      <!--              >17698861762</label>-->
      <!--              <label class="call" @click="handleCallClick('17637738312')">17637738312</label>-->
      <!--            </p>-->
      <!--          </div>-->
      <!--          <div v-else>-->
      <!--            <p>-->
      <!--              <label class="call" @click="handleCallClick('0377-60380518')">0377-60380518</label>-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <a :href="telPhone" v-show="false" ref="tels"></a>
  </div>
</template>

<script>
import { findInsureList, payInsure } from "@/api/common";
import { Toast, Notify } from "vant";
export default {
  data() {
    return {
      params: {
        page: 1,
        count: 5,
      },
      insureLists: [],
      isNoDate: false,
      telPhone: "",
      requestState: true,
    };
  },
  created() {
    document.title = "我的保单";
    this._findInsureList();
  },
  mounted() {
    window.addEventListener("scroll", this.handleFadeNavScroll);
  },
  methods: {
    handleFadeNavScroll() {
      if (!this.isNoDate && this.requestState) {
        this.params.page++;
        this._findInsureList();
      }
    },
    _findInsureList() {
      this.requestState = false;
      findInsureList(this.params).then((res) => {
        this.requestState = true;
        if (res.code == 0) {
          if (res.data.list.length < this.params.count) {
            this.isNoDate = true;
          }
          if (this.insureLists.length == 0) {
            this.insureLists = res.data.list;
          } else {
            this.insureLists = this.insureLists.concat(res.data.list);
          }
        }
      });
    },
    handleCallPhoneClick(item, index) {
      if (index == 1) {
        item.showCallPhone1 = item.showCallPhone1 ? false : true;
      } else {
        item.showCallPhone2 = item.showCallPhone2 ? false : true;
      }
      this.$forceUpdate();
    },
    handleCallClick(phone) {
      this.telPhone = "tel:" + phone;
      this.$nextTick(() => {
        this.$refs.tels.click();
      });
    },
    handlePayClick(item) {
      if (item.productId == "1") {
        window.location.href = item.payUrl;
      } else if (item.productId == "100") {
        Toast.loading({
          message: "支付中...",
          forbidClick: true,
          duration: 0,
        });
        payInsure({ id: item.id }).then((res) => {
          Toast.clear();
          if (res.code === 0) {
            var paymentMap = res.data;
            if (typeof WeixinJSBridge === "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.$ComTools.onBridgeReady(paymentMap, this.payCallback),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
                );
              }
            } else {
              this.$ComTools.onBridgeReady(paymentMap, this.payCallback);
            }
          } else {
            Notify({ type: "danger", message: res.msg });
          }
        });
      }
    },
    payCallback(index) {
      switch (index) {
        case 1:
          this.params.page = 1;
          this.insureLists = [];
          this.isNoDate = false;
          this._findInsureList();
          break;
        case 2:
          Toast("取消支付");
          WeixinJSBridge.call("closeWindow");
          break;
        case 3:
          Toast("支付失败");
          WeixinJSBridge.call("closeWindow");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100%;
  min-height: 100%;
  background-color: #f2f2f2;
  padding: 10px;
  .list-item {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 20px;
    .title {
      padding: 0.5rem;
      text-align: center;
      font-size: 1.2rem;
      border-bottom: 1px solid #efeff2;
      position: relative;
      .paylink {
        color: cornflowerblue;
        text-decoration: underline;
        position: absolute;
        right: 0.5rem;
        top: 0.8rem;
        font-size: 0.8rem;
      }
    }
    .time-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0.8rem 1rem;
      font-size: 12px;
      color: #b3b3b3;
      border-bottom: 1px solid #efeff2;
    }
    .content {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #efeff2;
      .content-item {
        width: 33.3%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem 0px;
        height: 5.5rem;
        justify-content: space-between;
        .content-item-value {
          font-weight: 600;
        }
      }
    }
    .phone-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0.8rem 1rem;
      flex-wrap: wrap;
      .left {
        font-size: 12px;
        color: #b3b3b3;
      }
      .right {
        color: #3faea9;
        text-decoration: underline;
      }
      .phone-content {
        width: 100%;
        p {
          width: 100%;
          display: flex;
          padding: 0.2rem 0;
        }
      }
    }
  }
  .no-date {
    width: 100%;
    text-align: center;
    margin-top: 5rem;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/insure_list.vue